import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isAuthenticated: false
  },
  getters: {
    isAuthenticated: state => state.isAuthenticated
  },
  mutations: {
    SET_AUTHENTICATED(state, status) {
      state.isAuthenticated = status
    }
  },
  actions: {
    login({ commit }) {
      commit('SET_AUTHENTICATED', true)
    },
    logout({ commit }) {
      commit('SET_AUTHENTICATED', false)
    }
  },
  modules: {
  }
})
